var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLoginMima(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_login_mima") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u624B\\u673A\\u53F7\\u767B\\u5F55",
    transform: "translate(-914, -347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_login_mima",
    transform: "translate(914, 347)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#14161E",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0495911,8.40018462 L15.3746593,8.40018462 L15.3746593,7.02830769 C15.3737568,5.13528551 13.8633989,3.60091679 12,3.6 C10.1366011,3.60091679 8.62624318,5.13528551 8.62534074,7.02830769 L8.62534074,8.40018462 L7.94931853,8.40018462 C7.20489235,8.40261824 6.60209482,9.01524613 6.6,9.77150769 L6.6,16.6281231 C6.60179694,17.3848163 7.20501251,17.9978689 7.94986371,18 L16.0495911,18 C16.7944431,17.9981745 17.3979023,17.3853693 17.4,16.6286769 L17.4,9.77150769 C17.3979023,9.01481527 16.7944431,8.40201012 16.0495911,8.40018462 Z M12,14.5716923 C11.2551488,14.5695613 10.6519332,13.9565086 10.6501363,13.1998154 C10.6522326,12.4433384 11.2553609,11.830622 12,11.8284923 C12.7446391,11.830622 13.3477674,12.4433384 13.3498637,13.1998154 C13.3480668,13.9565086 12.7448512,14.5695613 12,14.5716923 L12,14.5716923 Z M14.0923978,8.40018462 L9.90760222,8.40018462 L9.90760222,7.02830769 C9.90850415,5.85471698 10.8447744,4.90356243 12,4.90264615 C13.1552256,4.90356243 14.0914958,5.85471698 14.0923978,7.02830769 L14.0923978,8.40018462 L14.0923978,8.40018462 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginMima);
export default __webpack_public_path__ + "static/media/icon_login_mima.svg";
export { ForwardRef as ReactComponent };